import { render } from "./factoryManage.vue?vue&type=template&id=1f138d39&scoped=true"
import script from "./factoryManage.vue?vue&type=script&lang=js"
export * from "./factoryManage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f138d39"]])

export default __exports__